import {
  Button,
  CancelRoundedIcon,
  CheckIcon,
  WarningIcon,
} from "@mychili/clarity-ui";
import { cva } from "class-variance-authority";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import type { MerchantsTypes } from "../../api/client";

type PaymentStatusViewProps = {
  status?: MerchantsTypes.components["schemas"]["GetExternalOrderInfoRespV2"]["online_order_status"];
  redirectUrl?: string | null;
};

// @todo refactor with clarity-ui - TwoToneIcon component
const iconContainerClass = cva(
  "mx-auto flex h-[56px] w-[56px] items-center justify-center rounded-[50%]",
  {
    variants: {
      status: {
        PAYMENT_SUCCESSFUL: "bg-background-success",
        CANCELLED: "bg-background-danger",
        UNAVAILABLE: "bg-background-warning",
        PAYMENT_IN_PROGRESS: "bg-background-warning",
        REFUNDED: "bg-background-warning",
      },
    },
  },
);

export const PaymentStatusView = ({
  status,
  redirectUrl,
}: PaymentStatusViewProps) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleBackToShopClick = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      navigate(-1);
    }
  };

  const mappingData = {
    PAYMENT_SUCCESSFUL: {
      Icon: <CheckIcon className="text-icons-success" width={32} />,
      title: t("payment.status.success.title"),
      buttonText: t("payment.status.success.button_text"),
    },
    CANCELLED: {
      Icon: (
        <CancelRoundedIcon className="text-icons-danger" fontSize="large" />
      ),
      title: t("payment.status.failed.title"),
      buttonText: t("payment.status.failed.button_text"),
    },
    UNAVAILABLE: {
      Icon: <WarningIcon className="text-icons-warning" width={32} />,
      title: t("payment.status.expired.title"),
      buttonText: t("payment.status.expired.button_text"),
    },
    PAYMENT_IN_PROGRESS: {
      Icon: <WarningIcon className="text-icons-warning" width={32} />,
      title: t("payment.status.expired.title"),
      buttonText: t("payment.status.expired.button_text"),
    },
    REFUNDED: {
      Icon: <WarningIcon className="text-icons-warning" width={32} />,
      title: t("payment.status.expired.title"),
      buttonText: t("payment.status.expired.button_text"),
    },
  };

  if (!status) return null;

  return (
    <div className="flex justify-center">
      <div className="mx-5 max-w-[464px] rounded-lg bg-background-neutral p-8">
        <div className={iconContainerClass({ status })}>
          {mappingData[status]?.Icon}
        </div>

        <h3
          className="typography-headline-h3-medium mt-5 text-center text-text-neutral"
          color="neutral.20"
        >
          {mappingData[status]?.title}
        </h3>

        {status === "CANCELLED" ? (
          <p className="typography-regular-text-regular text-center text-icons-neutral-subtler">
            {t("payment.status.failed.description")}
          </p>
        ) : null}

        <Button className="mt-5 w-full" onClick={handleBackToShopClick}>
          {mappingData[status]?.buttonText}
        </Button>
      </div>
    </div>
  );
};
